import { Competition } from 'business';
import { useBatchedQuery } from 'bridge';

export default function useFeatured(region?: string) : [Competition[], () => void] {
    const [featured, onLoadMoreFeatured] = useBatchedQuery({ region: region, queryType: 'discoverFeatured'});
    return [featured, onLoadMoreFeatured];
}
